import { render, staticRenderFns } from "./SpellFields.vue?vue&type=template&id=4a67cde2"
import script from "./SpellFields.vue?vue&type=script&lang=js"
export * from "./SpellFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports